<div class="card">
    <div class="card-body">
        <h3>
            {{ strings.title }} {{ strings.count }}
            @if (strings.count !== '(0)' && !showParticipantList && notification.csmlTrackerUrl) {
                <span class="pace-link-font" paceCoreLink>
                    <a
                        class="pace-link"
                        href="{{ notification.csmlTrackerUrl }}"
                        target="_blank"
                        translate="TRACK_ALL_ORDERS"
                    >
                    </a>
                </span>
            }
        </h3>
        <carousel #carousel [noWrap]="true" [showIndicators]="false" interval="0">
            @if (slides.length === 0) {
                <slide class="no-records">
                    <span translate="NOTIFICATION_DETAILS_NO_RECORDS_AVAILABLE_TITLE"></span>
                </slide>
            }

            @for (slide of slides; track slide) {
                <slide paceSwipe (swipeLeft)="swipe($event)" (swipeRight)="swipe($event)">
                    <div class="row flex-nowrap mx-2 my-1">
                        @for (column of slide; track column) {
                            <div class="material-participants-section col d-flex flex-column px-0">
                                <!--Materials -->
                                @if (!showParticipantList) {
                                    <ng-container
                                        *ngTemplateOutlet="materialList; context: { $implicit: column }"
                                    ></ng-container>
                                } @else {
                                    <ng-container
                                        *ngTemplateOutlet="participantList; context: { $implicit: column }"
                                    ></ng-container>
                                }
                                <!--Participants -->
                            </div>
                        }
                    </div>
                </slide>
            }
            <div class="carousel-indicators">
                @for (slide of slides; track slide; let i = $index) {
                    <button
                        type="button"
                        aria-current="true"
                        [class.active]="i === carousel.activeSlide"
                        data-bs-target="#carousel1"
                        [attr.aria-label]="('NOTIFICATION_DETAILS_CAROUSEL_BUTTON_LABEL' | translate) + (i + 1)"
                        (click)="carousel.selectSlide(i)"
                    ></button>
                }
            </div>
        </carousel>
    </div>
    <!-- card-body -->
</div>
<!-- panel -->

<ng-template #materialList let-column>
    @for (item of column; track item) {
        <ul>
            <li class="user-select-auto horizontal-icons-list">
                {{ item.materialIdentifier.orderNumber.value }} | {{ item.materialIdentifier.orderPosition.value }} |
                {{ item.deliveredQuantity }} {{ item.quantityUnit.value }}
                @if (item.showDangerousInfo) {
                    <fa-icon [icon]="faExclamationTriangle"></fa-icon>
                }
                @if (item.isPurchaseOrderTaxiBillable) {
                    <fa-icon [icon]="faTaxi"></fa-icon>
                }
                @if (item.isQualityPart) {
                    <fa-icon [icon]="faSearch"></fa-icon>
                }
                @if (item.isRentalTool) {
                    <fa-icon [icon]="faWrench"></fa-icon>
                }
            </li>
            @if (item.csmlTrackerUrl) {
                <li paceCoreLink>
                    <a href="{{ item.csmlTrackerUrl }}" class="pace-link" target="_blank" translate="TRACK_ORDER"></a>
                </li>
            }
            <li class="user-select-auto">
                {{ item.description.value }}
                @if (item.smartSensorTrackerUrl.length > 0) {
                    <span paceCoreLink>
                        <a
                            href="{{ item.smartSensorTrackerUrl }}{{ item.materialIdentifier.orderNumber.value }}"
                            class="pace-link"
                            target="_blank"
                            [attr.aria-label]="'NOTIFICATION_DETAILS_LINK_TO_SMART_SENSOR_TRACKER_LABEL' | translate"
                            ><fa-icon [icon]="faExternalLinkSquareAlt"></fa-icon></a
                    ></span>
                }
            </li>
            <li>
                @if (sparePartCatalogMatLink) {
                    <span class="user-select-auto" paceCoreLink>
                        {{ item.materialIdentifier.materialNumber.value }}
                        <a
                            class="pace-link"
                            target="_blank"
                            href="{{ sparePartCatalogMatLink }}&partnum={{
                                item.materialIdentifier.materialNumber.value
                            }}"
                            [attr.aria-label]="'NOTIFICATION_DETAILS_LINK_TO_SPARE_PARTS_CATALOG_LABEL' | translate"
                        >
                            <fa-icon [icon]="faExternalLinkSquareAlt"></fa-icon>
                        </a>
                    </span>
                }
                @if (!sparePartCatalogMatLink) {
                    <span>({{ item.materialIdentifier.materialNumber.value }})</span>
                }
            </li>
            @if (!getMaterialPickedUpQuantity(item)) {
                <li class="d-flex align-items-center">
                    <span> <fa-icon [icon]="faInfoCircle"></fa-icon>&nbsp; </span>
                    @if (!item.materialStatus.isNotReceived) {
                        <button class="btn btn-link ps-0" (click)="openPickupModal(item)">
                            <span translate="NOTIFICATION_DETAILS_MATERIAL_PICKUP_LABEL"></span>
                        </button>
                    }
                    @if (item.materialStatus.isNotReceived) {
                        <span class="text-muted" translate="NOTIFICATION_DETAILS_MATERIAL_NOT_RECEIVED_LABEL"></span>
                    }
                </li>
            }
            @if (getMaterialPickedUpQuantity(item)) {
                <li>
                    {{ getMaterialPickedUpQuantity(item) }}
                    <span translate="MATERIAL_PICKUP_PICKED_STATUS"></span>
                </li>
            }
        </ul>
    }
</ng-template>

<ng-template #participantList let-column>
    @for (item of column; track item) {
        <ul>
            <li>
                {{ item.lastName.value }}
                @if (item.lastName.value && item.firstName.value) {
                    <span>,</span>
                }
                {{ item.firstName.value }}
            </li>
            <li>
                <a (click)="openEmail(item.mail.value)">{{ item.mail.value }}</a>
            </li>
        </ul>
    }
</ng-template>
